/**
 * The type of (redux) action which signals that the controller is capturing mouse and keyboard events.
 *
 * {
 *     type: CAPTURE_PAY_EVENTS,
 *     isCapturingEvents: boolean
 * }
 */
export const CAPTURE_PAY_EVENTS = 'CAPTURE_PAY_EVENTS';
/**
 * The type of (redux) action which signals that a remote control active state has changed.
 *
 * {
 *     type: PAY_ACTIVE,
 *     active: boolean
 * }
 */
export const PAY_ACTIVE = 'PAY_ACTIVE';
/**
 * The type of (redux) action which sets the receiver transport object.
 *
 * {
 *     type: SET_RECEIVER_PAY_TRANSPORT,
 *     transport: Transport
 * }
 */
export const SET_RECEIVER_PAY_TRANSPORT = 'SET_RECEIVER_PAY_TRANSPORT';
/**
 * The type of (redux) action which enables the receiver.
 *
 * {
 *     type: SET_RECEIVER_PAY_ENABLED,
 *     enabled: boolean
 * }
 */
export const SET_RECEIVER_PAY_ENABLED = 'SET_RECEIVER_PAY_ENABLED';
/**
 * The type of (redux) action which sets the controller participant on the receiver side.
 * {
 *     type: SET_PAY_CONTROLLER,
 *     controller: string
 * }
 */
export const SET_PAY_CONTROLLER = 'SET_PAY_CONTROLLER';
/**
 * The type of (redux) action which sets the controlled participant on the controller side.
 * {
 *     type: SET_CONTROLLED_PAY_PARTICIPANT,
 *     controlled: string
 * }
 */
export const SET_CONTROLLED_PAY_PARTICIPANT = 'SET_CONTROLLED_PAY_PARTICIPANT';
/**
 * The type of (redux) action which sets the requested participant on the controller side.
 * {
 *     type: SET_REQUESTED_PAY_PARTICIPANT,
 *     requestedParticipant: string
 * }
 */
export const SET_REQUESTED_PAY_PARTICIPANT = 'SET_REQUESTED_PAY_PARTICIPANT';
